import { Message } from "@/components/basic";
import { useUserInfo } from "@/components/business/user-info-provider";
import useRouter from "@/hoc/use-router";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router";

const LoginMiddlewares: React.FC = () => {
  const { router } = useRouter();
  const [loading, setLoading] = useState<boolean>(true);

  const { userInfo, freshUserInfo } = useUserInfo();

  const fetchUserInfo = () => {
    const notice = Message.loading();
    setLoading(true);
    freshUserInfo()
      .then((status) => {
        if (!status) {
          // router.push("/login");
          router.push("/500");
        }
      })
      .finally(() => {
        notice.destroy();
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!userInfo) {
      fetchUserInfo();
    } else {
      setLoading(false);
    }
  }, []);

  return !loading ? <Outlet /> : null;
};

export default LoginMiddlewares;
